import * as React from 'react';

import { Button, Flex, Text } from '@ttoss/ui';
import { useNavigation } from './components';

export type InstallPwaUiProps = {
  onInstall: React.MouseEventHandler<HTMLButtonElement>;
  onClose: React.MouseEventHandler<HTMLButtonElement>;
};

export const InstallPwaUi = ({ onInstall, onClose }: InstallPwaUiProps) => {
  return (
    <Flex
      sx={{
        position: 'fixed',
        top: '127px',
        width: '100%',
        maxWidth: '600px',
        left: [null, '10%'],
      }}
    >
      <Flex
        sx={{
          backgroundColor: 'primary',
          alignItems: 'center',
          gap: 4,
          width: '100%',
          border: '1px solid',
          borderColor: 'transparent',
          paddingY: 7,
          paddingX: 6,
          borderBlockColor: 'none',
          boxShadow: '0px 4px 4px rgb(0 0 0 / 15%)',
        }}
      >
        <Text sx={{ color: '#fff', width: '100%' }}>
          Deseja instalar o aplicativo?
        </Text>

        <Flex
          sx={{
            width: '100%',
            justifyContent: 'flex-end',
            gap: 4,
          }}
        >
          <Button
            variant="muted"
            onClick={onClose}
            sx={{
              backgroundColor: 'background',
              color: 'black',
              paddingX: 6,
              paddingY: 3,
            }}
          >
            Fechar
          </Button>
          <Button
            variant="cta"
            onClick={onInstall}
            sx={{
              backgroundColor: 'background',
              color: 'black',
              paddingX: 6,
              paddingY: 3,
            }}
          >
            Instalar
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

const useUserDoesNotWantToInstallPwa = () => {
  const localStorageKey = 'userDoesNotWantToInstallPwa';

  const [userDoesNotWantToInstallPwa, setUserDoesNotWantToInstallPwa] =
    React.useState(true);

  React.useEffect(() => {
    const userDoesNotWantToInstallPwa = localStorage.getItem(localStorageKey);
    setUserDoesNotWantToInstallPwa(userDoesNotWantToInstallPwa === 'true');
  }, []);

  const handleClose = () => {
    localStorage.setItem(localStorageKey, 'true');
    setUserDoesNotWantToInstallPwa(true);
  };

  return {
    userDoesNotWantToInstallPwa,
    handleClose,
  };
};

export const InstallPwa = () => {
  const [supportsPwa, setSupportsPwa] = React.useState(true);
  const [promptInstall, setPromptInstall] = React.useState<any>(null);
  const [isInstalled, setIsInstalled] = React.useState(false);
  const { onboardIsFinished } = useNavigation();

  React.useEffect(() => {
    const beforeInstallHandler = (e: any) => {
      e.preventDefault();
      setSupportsPwa(true);
      setPromptInstall(e);
    };

    window.addEventListener('beforeinstallprompt', beforeInstallHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
    };
  }, []);

  const { userDoesNotWantToInstallPwa, handleClose } =
    useUserDoesNotWantToInstallPwa();

  const onInstall = async (e: any) => {
    e.preventDefault();

    if (!promptInstall) {
      return;
    }

    const { outcome } = await promptInstall.prompt();

    if (outcome === 'accepted') {
      setIsInstalled(true);
    }
  };

  if (!onboardIsFinished) {
    return null;
  }

  if (!supportsPwa) {
    return null;
  }

  if (isInstalled) {
    return null;
  }

  if (userDoesNotWantToInstallPwa) {
    return null;
  }

  return <InstallPwaUi onInstall={onInstall} onClose={handleClose} />;
};
